export function triggerPlannerSync() {
  window.dispatchEvent(new CustomEvent('plannerSyncUpdated'));
}
